export default __webpack_public_path__ + "static/ThomasTierney-04fc7df704de5d7f00e367c7f64487c6.jpg";